/*!
 * Copyright (c) REWE Digital GmbH
 */
import { Host, h } from "@stencil/core";
/**
 * VX Popover component.
 */
// eslint-disable-next-line require-jsdoc
export class VxPopover {
    constructor() {
        this.isOpen = false;
        this.triggerElement = undefined;
    }
    /**
     * Handles the closing of the info card when clicking outside of the info card happens.
     */
    handleOutsideClick(e) {
        if (!e.composedPath().includes(this.host) &&
            !e.composedPath().includes(this.triggerElement)) {
            this.isOpen = false;
        }
    }
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        return (h(Host, { key: '24bc8dd32579b337a0c4e0e5ba6f2678e004913e', style: { display: this.isOpen ? 'grid' : 'none' } }, h("slot", { key: '78c6dcf749e2a6173a895895d88854e44761ffa2' })));
    }
    static get is() { return "vx-popover"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-popover.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-popover.css"]
        };
    }
    static get properties() {
        return {
            "isOpen": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "is-open",
                "reflect": false,
                "defaultValue": "false"
            },
            "triggerElement": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLElement",
                    "resolved": "HTMLElement",
                    "references": {
                        "HTMLElement": {
                            "location": "global",
                            "id": "global::HTMLElement"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                }
            }
        };
    }
    static get elementRef() { return "host"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "handleOutsideClick",
                "target": "document",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=vx-popover.js.map
